import { alpha } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      overflow: 'auto',
      width: '99%',
      margin: theme.spacing(0.625),
    },
    error: {
      color: Colors.red,
    },
    selectedAll: {
      backgroundColor: alpha(Colors.black, 0.08),
      '&:hover': {
        backgroundColor: alpha(Colors.black, 0.08),
      },
    },
    indeterminateColor: {
      color: Colors.pink_red,
    },
    selectAllText: {
      fontWeight: 500,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: theme.spacing(0.25),
      fontSize: 14,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 400,
      fontSize: 14,
    },
    optionSelect: {
      fontSize: 14,
      '& .MuiSelect-select': {
        padding: '13px 24px 13px 12px',
      },
    },
    groupCell: {
      whiteSpace: 'pre-wrap',
    },
  }),
);
